import { Container } from "./styles";
import emailIcon from "../../assets/email-icon.svg";
import phoneIcon from "../../assets/phone-icon.svg"
import telegramIcon from "../../assets/telegram.png"


export function Contact() {

  return (
    <Container id="contact">
      <header>
        <h2>Kontakt</h2>
        <p>Agar siz mening salohiyatimni ko'rgan bo'lsangiz yoki men bilan gaplashmoqchi bo'lsangiz, menga xabar yuboring</p>
      </header>
      <div className="contacts">
        <a className="link-tag" target="_blank" href="mailto:azizshodmonhojaev222@gmail.com">
          <div>
            <img src={emailIcon} alt="Email" />
            <span>azizshodmonhojaev222@gmail.com</span>
          </div>
        </a>
        <a className="link-tag" target="_blank" href="tel:+998971671222">
          <div>
            <img src={phoneIcon} alt="Email" />
            <span>(97) 167-12-22</span>
          </div>
        </a>

        <a className="link-tag" target="_blank" href="https://t.me/shodmonhojaev">
          <div>
            <img src={telegramIcon} alt="Email" />
            <span>Azizxon Shodmonhojaev</span>
          </div>
        </a>
      </div>
    </Container>
  )
}